import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../../hoc/Loading/Loading';
import axios from '../../../../axios';
import * as actionCreators from '../../../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../../../utils/url';
import Toggle from "react-toggle";
// import DashboardChartList from './AddCharts/DashboardChartList'
import { Form, FormGroup, FormFeedback, Col, Label, Input, Button, 
  Row, CustomInput, Popover, PopoverHeader, PopoverBody,
  Dropdown, DropdownItem, DropdownToggle, DropdownMenu,
  Modal, ModalBody, ModalHeader, Table
} from "reactstrap";
import Checkbox from 'rc-checkbox';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import DashboardSettings from './DashboardSettings/DashboardSettings'
import DashboardListTable from './DashboardListTable'
import Select from "react-select";
import ModulesAnalytics from './ModuleAnalytics';



class DashboardList extends Component {
  constructor(props) {
    super(props);
    this.state = { 
        updatedFields:[],
        title:'',
        isChartList:false,
        dashboardCharts:[],
        dashboardTools:[],
        currentDashboard:null,
        linkedItems:[],
        allItems:[],
        notes:[],
        attachments:[],
        linkedItemsCount:null,
        isResourceSelect:null,
        searchedTerm:'',
     }
  }

  componentDidMount(){
    this.props.updateReport()
    // this.fetchCharts()
  }
   

changeDashboardTitle = (name) => {
    let{currentDashboard}=this.state
    let obj={
      ...currentDashboard,
      name
    }
    this.setState({ currentDashboard:obj })
  }


  dateChange=(startDate,endDate)=>{
    let{currentDashboard}=this.state
    let obj={
      ...currentDashboard,
      startDate,
      endDate
    }
    this.setState({ currentDashboard:obj })
  }

 
navigate=()=>{
    this.props.history.push('/home/analytics/all')
  }

  
closeActionsModal=()=>{
  this.setState({
    isResourceSelect:null
  })
}




renderPrivacyOptions=()=>{
  return this.privacyContent("enable")
  // if(chartDetails && chartDetails.createdBy  && chartDetails.createdBy._id){
  //     if(chartDetails.createdBy._id===user._id){
  //       return this.privacyContent("enable")
  //     } else if(isCopied) {
  //       return this.privacyContent("enable")
  //     } else {
  //       return this.privacyContent("disable")
  //     }
  // } else {
  //   return this.privacyContent("enable")
  // }
}
 


renderPermissions=()=>{
  let{privacy, invitedUsers, displayUsers, isUserList, customUser}=this.state
  if(privacy=='ENTERPRISE'){
    return(
      <span className="permissionsContainer">
        
         <span className="dashboard-permission-label">Permissions:</span>
      
       <div className="dashboardPermissionOptions">
         <span className="dbPermissionValue">View Only</span>
         <span className="ml10">
           <Toggle
             defaultChecked={this.state.permission === 'EDIT'}
             icons={false}
             onChange={this.handlePermissionChange}
           />
         </span>
         <span className="dbPermissionValue ml10">View And Edit</span>
       </div>
     </span>
    )
  } else if(privacy=='CUSTOM' && isUserList){
    return(
      <span>
   
            <span className="permissionsContainer">
            <Input
                  name="assignedUser"
                  id=""
                  placeholder={"Select users to share this dashboard with"} 
                  className="inputBox-height"
                  onChange={this.assignedUserDelay}
                  value={customUser} 
                  autoComplete={'off'}
                />
                  {displayUsers && displayUsers.length>0 && typeof(displayUsers)!=='string'?
                          <div className="divTableSingleTask">
                          <div className="dbTableBody">
                              
                                {displayUsers.map( user => {
                                  return (
                                      <div className="divTableRow" 
                                      onClick={()=>this.onUserSelect(user)} 
                                      key={user._id+user.organizationId}>
                                          <div className="dashboardTableCell">
                                            {user.firstName} {user.lastName}
                                          </div>
                                      </div>
                                  )
                                })}
                          </div>
                          </div>
                    :
                    typeof(displayUsers)==='string'?
                    <span className='noUsersFound'>
                      {displayUsers}
                    </span>
                    :null
                    }
         
             </span>
             
          {invitedUsers.length>0?
            <Table responsive hover className="dbPrivacyTable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Access</th>
                </tr>
              </thead>
              <tbody>
                {invitedUsers.map(e=>{
                  let fullName= e.firstName + " " +e.lastName
                  return(
                    <tr className="dbPrivacyRow" key={e.userId} >
                      
                      <td >
                        {fullName}
                      </td>

                        <td>
                              <Select
                                isClearable={false}

                                  name="permission-select" 
                                  placeholder={"Select a permission/privacy"} 
                                  value={e.permissions} 
                                  isOpen={true}
                                  options={[
                                    {label: 'View', value:0},
                                    {label: 'Edit', value:1},
                                  ]} 
                                  onChange={itm =>this.onUserSetPermissions(itm, e)}  
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  />
                        </td>
                    </tr>
                  )
                })}
              </tbody>
              </Table>
          :
          null}
    
        </span>
    )
  }
}

  render() { 
      let{updatedFields,title, isChartList,dashboardCharts,startDate,endDate, linkedItems,
        currentDashboard, linkedItemsCount, isResourceSelect}=this.state
    return (
        <div className="dashboardListContainer col-md-10 ml-5 pl-4">
   
            <span className='dashboardListTitleContainer'>
                <h5 className="dashboardListTitleInput "  > Dashboards </h5>
            </span>

        <DashboardSettings />

        <div style={{marginBottom:"2em"}}>
        <DashboardListTable />
        </div>
      


        {/* <ModulesAnalytics /> */}
          
       
        <ModulesAnalytics />

        </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),

  }
}
 
// export default LinkedCharts;
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(DashboardList, axios)));
